import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TranscriptCourseStatusService from "../../src/Services/TranscriptCourseStatus.service";
const TranscriptCourseStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "description",
        fetchItemsById: (ids) => {
            return TranscriptCourseStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TranscriptCourseStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(transcriptCourseStatus) {
            return _jsx("span", { children: transcriptCourseStatus.description });
        },
    });
};
export default TranscriptCourseStatusLookup;
